import axios from 'axios';
import config from '../config/config';


const instance = axios.create({
  baseURL: config.apiUrl,
  withCredentials: false, // Вимикаємо credentials для AWS API Gateway
  timeout: 30000 // 30 секунд таймаут
});

// Додаємо перехоплювач для додавання токену до кожного запиту
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Додаємо перехоплювач відповідей для логування помилок
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', {
      url: error.config?.url,
      method: error.config?.method,
      status: error.response?.status,
      statusText: error.response?.statusText,
      data: error.response?.data,
      message: error.message
    });
    return Promise.reject(error);
  }
);

export default instance; 